<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteSelect from '../../sites/components/SiteSelect.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: false,
        hideHeader: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteSelect />
</template>